import { createFileRoute } from "@tanstack/react-router";
import { getArticles } from "@/lib/server-functions";
import ArticlesList from "@/pages/ArticlesList";
import ogImage from "@/assets/knmc-og.jpeg";
import { getPageUrl } from "@/lib/site";
import { articlesListJsonLd } from "@/lib/jsonld";

export const Route = createFileRoute("/health-articles/")({
  loader: async () => {
    const articles = await getArticles();
    return { articles };
  },

  head: ({ loaderData }) => {
    const pageUrl = getPageUrl("/health-articles");

    return {
      meta: [
        {
          title: "Health Articles & Tips — KNMC Kathmandu, Nepal",
        },
        {
          name: "description",
          content:
            "Expert health insights and wellness tips from KNMC doctors in Kathmandu, Nepal — evidence-based advice for everyday care.",
        },
        {
          name: "keywords",
          content:
            "health blog Nepal, wellness tips Kathmandu, medical advice Nepal, KNMC articles",
        },
        {
          property: "og:title",
          content: "Health Articles — KNMC Kathmandu",
        },
        {
          property: "og:description",
          content:
            "Trusted health advice from Nepal's leading hospital in Kathmandu.",
        },
        {
          property: "og:image",
          content: getPageUrl(ogImage),
        },
        {
          property: "og:url",
          content: pageUrl,
        },
        articlesListJsonLd(loaderData?.articles ?? []),
      ],

      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: () => {
    const { articles } = Route.useLoaderData();
    return <ArticlesList articles={articles} />;
  },
});